<template>
    <v-container>
        <div class="jjglhome">
            <div class="mainHTML">
                <div class="menu">
                    <a v-for="item in heedIfo">
                        <img  :src="item.imgUrl" class="listitemimage"  @click="linkFun(item)"/>
                    </a>
                </div>
                <div class="mainRoute">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
    export default {
        name: "jjjggs_home",
        data() {
            return{
                heedIfo:[
                    {
                        href: '/ywhome/jjgl/jjjggs',
                        imgUrl: require("../img2/jjgl/jjjggs_1.png"),
                        title: '经济机构公示',
                        id:"1"
                    },
                    {
                        href: '/ywhome/jjgl/zlqygs',
                        imgUrl: require("../img2/jjgl/zlqygs_1.png"),
                        title: '租赁企业公示',
                        id:"2"
                    },
                    {
                        href: '/ywhome/jjgl/qycyrygs',
                        imgUrl: require("../img2/jjgl/cyrygs_1.png"),
                        title: '从业人员公示',
                        id:"3"
                    },
                    {
                        href: '/ywhome/jjgl/jypjgs',
                        imgUrl: require("../img2/jjgl/jypjgs_1.png"),
                        title: '交易评价公示',
                        id:"4"
                    },
                    {
                        href: '/ywhome/jjgl/xyphb',
                        imgUrl: require("../img2/jjgl/xyphb_1.png"),
                        title: '信用排行榜',
                        id:"5"
                    },
                    {
                        href: '/ywhome/jjgl/xyxjgs',
                        imgUrl: require("../img2/jjgl/xyxjgs_1.png"),
                        title: '信用星级公示',
                        id:"6"
                    },
                    {
                        href: '/ywhome/jjgl/xyda',
                        imgUrl: require("../img2/jjgl/xyda_1.png"),
                        title: '信用档案',
                        id:"7"
                    },
                    {
                        href: '/ywhome/jjgl/jyphb',
                        imgUrl: require("../img2/jjgl/jyphb_1.png"),
                        title: '交易排行榜',
                        id:"7"
                    }
                ]
            }
        },
        methods: {
            copy(e) {
                // handleClipboard(e.target.innerHTML, e);
            },
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            linkFun(item){
                if(item.href=="/ywhome/jjgl/jypjgs"||item.href=="/ywhome/jjgl/xyphb"||item.href=="/ywhome/jjgl/xyxjgs"||item.href=="/ywhome/jjgl/xyda"){
                    this.warnMessage("功能正完善中...");
                }else {
                    this.$router.push({path: item.href, query: {id: item.href}})
                }
            }
        },
    }
</script>


<style scoped>
    /*我是移动端*/
    @media screen and (max-width: 414px) {
        .menu{
            width: 100%;
            text-align: center;
        }

        .menu a{
            margin-top: 2%;
            width: 50%;
        }
        .menu img{
            width: 45%;
            margin-right: 10px;
        }
        .v-application{
            background-color: antiquewhite !important;
        }
    }
    /*我是PC端*/
    @media screen and (min-width: 414px) {
        .jjglhome{
            width: 1180px;
            margin: auto;
        }
        .menu{
            width: 240px;
            float: left;
            margin-top: 25px;
        }
        .mainRoute{
            width: 900px;
            float: left;
        }
        .menu img{
            width: 230px;
            margin-right: 18px;
            margin-top:5px;
        }
        .menu{
            display: flex;
            flex-flow:column;
        }
        .menu .img{
            display: inline-block;
            margin-right: 30px;
        }

    }
    .listitemimage:hover{
        transform: scale(1.07);
        transition: all 0.5s;
    }
    .jjglhome .mainRoute{

    }
    .jjglhome .mainHTML{

    }
</style>
<style scoped>
    ::-webkit-scrollbar {
        width: 0 !important;
    }
    ::-webkit-scrollbar {
        width: 0 !important;height: 0;
    }
</style>